'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripDashboardV1.$inject = ['ApiService'];


var _ = {
    each: _each3.default
};

var _module = angular.module('cb.strips.cbStripDashboardV1', []);

_module.directive('cbStripDashboardV1', cbStripDashboardV1);

exports.default = _module;


function cbStripDashboardV1(ApiService) {
    return {
        restrict: 'A',
        link: cbStripDashboardV1Link
    };

    function cbStripDashboardV1Link(scope, element, attr) {

        /* Get each content-block ('services') and register its controller with the defined getters and setters
         * Usage:
         *
         *  cb('dashboard-services', 'set', [index], {
         *      services: {
         *          title: ...,
         *          service: {
         *              index: [index],
         *              link: ...,
         *              href: ...
         *          }
         *      }
         *  });
         *
         * Note: do not use parameter [index] if only one content-block--services exists
         *
         * To use the getter in Relay or other code blocks
         * var s;
         * cb('dashboard-services', 'get', [index], (services) => { s = services; });
         */
        _.each(element.find('.content-block--services'), function (contentBlockElement) {
            contentBlockElement = angular.element(contentBlockElement);
            var _gettersAndSetters = addServicesGettersAndSetters(contentBlockElement);
            var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

            ApiService.attach({
                'dashboard-services': gettersAndSetters
            });
        });

        /* Get each content-block ('highlight') and register its controller with the defined getters and setters
         * Usage:
         *
         *  cb('dashboard-highlight', 'set', [index], {
         *      highlight: {
         *          title: ...,
         *          text: ...,
         *          link: ...,
         *          href: ...
         *      }
         *  });
         *
         * Note: do not use parameter [index] if only one content-block-highlight exists
         *
         * To use the getter in Relay or other code blocks
         * var h;
         * cb('dashboard-highlight', 'get', [index], (highlight) => { h = highlight; });
         */
        _.each(element.find('.content-block--highlight'), function (contentBlockElement) {
            contentBlockElement = angular.element(contentBlockElement);
            var _gettersAndSetters = addHighlightGettersAndSetters(contentBlockElement);
            var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

            ApiService.attach({
                'dashboard-highlight': gettersAndSetters
            });
        });
    }

    // Define getters and setters, used in cb-functions
    function addServicesGettersAndSetters(element) {
        var services = {};

        Object.defineProperty(services, 'services', {
            get: function get() {
                return element.find('.dashboard-content-block__nav-list__title').html();
            },
            set: function set(newValue) {
                if (newValue.title) {
                    element.find('.dashboard-content-block__nav-list__title').html(newValue.title);
                }
                if (newValue.service) {
                    var service = angular.element(element).find('a.link.nav-list__link');
                    var index = newValue.service.index || 0;

                    service[index].innerHTML = newValue.service.link;
                    service[index].href = newValue.service.href;
                }
            }
        });

        return services;
    }

    function addHighlightGettersAndSetters(element) {
        var highlight = {};

        Object.defineProperty(highlight, 'title', {
            get: function get() {
                return element.find('.dashboard-content-block__highlight__title').html();
            },
            set: function set(newValue) {
                element.find('.dashboard-content-block__highlight__title').html(newValue);
            }
        });

        Object.defineProperty(highlight, 'text', {
            get: function get() {
                return element.find('.text').html();
            },
            set: function set(newValue) {
                element.find('.text').html(newValue);
            }
        });

        Object.defineProperty(highlight, 'link', {
            get: function get() {
                return element.find('a.link.link--arrow-right').text();
            },
            set: function set(newValue) {
                element.find('a.link.link--arrow-right').text(newValue);
            }
        });

        Object.defineProperty(highlight, 'href', {
            get: function get() {
                return element.find('a.link.link--dashboard').attr('href');
            },
            set: function set(newValue) {
                element.find('a.link.link--dashboard').attr('href', newValue);
            }
        });

        return highlight;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/dashboard-v1/dashboard.directive.js
// module id = 938
// module chunks = 1